import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
  padding: 40px 20px;

  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`;

export const Header = styled.div`
  margin-bottom: 48px;
  text-align: center;

  @media (max-width: 768px) {
    margin-bottom: 36px;
  }
`;

export const Title = styled.h1`
  font-family: 'Unimed-Sans-Bold', sans-serif;
  font-size: 2.2rem;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.palet.institutional || '#00995D'};
  margin-bottom: 16px;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 12px;
  }

  @media (max-width: 480px) {
    font-size: 1.6rem;
  }
`;

export const Subtitle = styled.p`
  font-family: 'Unimed-Sans-Regular', sans-serif;
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.text.secondary || '#666'};
  line-height: 1.5;
  margin: 0;
  max-width: 600px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const MainCardSection = styled.div`
  flex: 1;
  background: white;
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 8px 32px rgba(0, 153, 93, 0.08);
  border: 1px solid rgba(0, 153, 93, 0.1);
  min-height: 500px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(
      90deg,
      ${(props) => props.theme.colors.palet.institutional || '#00995D'} 0%,
      ${(props) => props.theme.colors.palet.institutional2 || '#00401A'} 100%
    );
  }

  @media (max-width: 768px) {
    padding: 24px;
    border-radius: 20px;
  }
`;

export const CardSelectorSection = styled.div`
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid rgba(0, 153, 93, 0.1);

  @media (max-width: 768px) {
    margin-bottom: 24px;
    padding-bottom: 20px;
  }
`;

export const CardsDisplaySection = styled.div`
  flex: 1;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 80px 20px;
  background: white;
  border-radius: 24px;
  box-shadow: 0 8px 32px rgba(0, 153, 93, 0.08);
  border: 1px solid rgba(0, 153, 93, 0.1);

  h2 {
    font-family: 'Unimed-Sans-SemiBold', sans-serif;
    font-size: 1.6rem;
    color: ${(props) => props.theme.colors.text.primary || '#333'};
    margin-bottom: 16px;
  }

  p {
    font-family: 'Unimed-Sans-Regular', sans-serif;
    font-size: 1.1rem;
    color: ${(props) => props.theme.colors.text.secondary || '#666'};
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    padding: 60px 20px;
    border-radius: 20px;

    h2 {
      font-size: 1.4rem;
    }

    p {
      font-size: 1rem;
    }
  }
`;

export const ErrorMessage = styled.div`
  background: linear-gradient(135deg, #fee 0%, #fdd 100%);
  border: 1px solid #f99;
  border-radius: 16px;
  padding: 20px;
  margin-top: 24px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(255, 0, 0, 0.1);

  p {
    color: #c33;
    font-family: 'Unimed-Sans-SemiBold', sans-serif;
    margin: 0;
    font-size: 1rem;
  }
`;

export const LogoSection = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;

  img {
    height: 60px;
    width: auto;
  }

  @media (max-width: 768px) {
    margin-bottom: 24px;

    img {
      height: 50px;
    }
  }
`;
